import PropTypes from 'prop-types';

export default function OutlineBank(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <rect
                height="3"
                width="18"
                rx="1"
                stroke={color}
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                x="1"
                y="16"
            />
            <path
                d="M1 6.118a1 1 0 0 1 .553-.894l8-4a1 1 0 0 1 .894 0l8 4a1 1 0 0 1 .553.894V7.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6.118Z"
                stroke={color}
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
            <path d="M3.25 16V8M6.75 16V8M10.25 16V8M13.75 16V8M17.25 16V8" stroke={color} strokeWidth={strokeWidth} />
        </svg>
    );
}

OutlineBank.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
